import React, { FormEvent, useEffect, useState } from "react";
import styles from "../assets/styles/login.module.css";
import {
    FormGroup,
    IconButton,
    InputAdornment,
    TextField,
} from "@mui/material";
import {
    HidePasswordIcon,
    ShowPasswordIcon,
} from "../utils/functions/Icons";
import logo from "../assets/images/login/logo.svg";
import logo2 from "../assets/images/layout/sidebarlogo.png";
import girlImg from "../assets/images/login/groupimg.png";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import BtnLoader from "../components/common/BtnLoader";
import { externalSignupApi, signupApi } from "../utils/api/services";
import { handleKeyPress } from "../utils/functions/common";

interface SignupTypes {
    // origin_company: string;
    // origin_company_address: string;
    // origin_company_code: string;
    company_name: string;
    company_address: string;
    employee_name: string;
    employee_email: string;
    employee_mobile: string;
    employee_password: string;
}

const Signup = () => {
    const [signupData, setSignupData] = useState<SignupTypes>({
        // origin_company: "",
        // origin_company_address: "",
        // origin_company_code: "",
        company_name: "",
        company_address: "",
        employee_name: "",
        employee_email: "",
        employee_mobile: "",
        employee_password: "",
    });
    const [showPassword, setShowPassword] = useState(false);
    const [btnLoading, setBtnLoading] = useState(false);
    const navigate = useNavigate();
    const employer_id = new URLSearchParams(window.location.search).get('employer_id');

    useEffect(() => {
        if (employer_id) {
            sessionStorage.setItem('employer_id', employer_id);
        }
    }, [employer_id]);

    const handleChangeSignup = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = e.target;
        setSignupData({
            ...signupData,
            [name]: value,
        });
    };

    const handleSignup = async (e: FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        try {
            const sendData = {
                employer_id: employer_id,
                company_name: signupData.company_name,
                company_address: signupData.company_address,
                employee_name: signupData.employee_name,
                employee_email: signupData.employee_email,
                employee_mobile: signupData.employee_mobile,
                employee_password: signupData.employee_password,
            }
            setBtnLoading(true);
            const result = await externalSignupApi(sendData);
            if (result?.success) {
                toast.success(result?.message || "Signup successful!");
                setBtnLoading(false);
                navigate("/login");
            } else {
                setBtnLoading(false);
                toast.error(result?.message || "Signup failed!");
            }
        } catch (error: any) {
            setBtnLoading(false);
            toast.error(error?.message || "Something went wrong!");
        }
    };

    return (
        <div className={styles.loginMain}>
            <div className={`${styles.logo} ${styles.showOnlyOnMobile}`}>
                <img src={logo2} alt="logo" />
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 h-full">
                <section className={`${styles.bannerSection}`}>
                    <div className={styles.logo}>
                        <img src={logo} alt="logo" />
                    </div>
                    <div className={styles.girlImg}>
                        <img src={girlImg} alt="girl" />
                    </div>
                </section>
                <section className={`${styles.formSection} overflow-auto`}>
                    <div className={`${styles.formBox} w-full`}>
                        <div className={styles.loginHead}>
                            <h3>Welcome!</h3>
                            <p>Create your AkosMD account</p>
                        </div>
                        <form noValidate={false} onSubmit={handleSignup}>
                            <div className={`grid grid-cols-1 lg:grid-cols-2 gap-4 mx-4 ${styles.signupForm}`}>
                                <FormGroup className="customFormGroup mt-4">
                                    <TextField
                                        name="company_name"
                                        value={signupData.company_name}
                                        onChange={handleChangeSignup}
                                        placeholder="Company Name *"
                                        required
                                        className="custumTextField"
                                    />
                                </FormGroup>
                                <FormGroup className="customFormGroup mt-4">
                                    <TextField
                                        name="company_address"
                                        value={signupData.company_address}
                                        onChange={handleChangeSignup}
                                        placeholder="Company Address *"
                                        required
                                        className="custumTextField"
                                    />
                                </FormGroup>
                                <FormGroup className="customFormGroup mt-4">
                                    <TextField
                                        name="employee_name"
                                        value={signupData.employee_name}
                                        onChange={handleChangeSignup}
                                        placeholder="Employee Name *"
                                        required
                                        className="custumTextField"
                                    />
                                </FormGroup>
                                <FormGroup className="customFormGroup mt-4">
                                    <TextField
                                        type="email"
                                        name="employee_email"
                                        value={signupData.employee_email}
                                        onChange={handleChangeSignup}
                                        placeholder="Employee Email *"
                                        required
                                        className="custumTextField"
                                    />
                                </FormGroup>
                                <FormGroup className="customFormGroup mt-4">
                                    <TextField
                                        type="text"
                                        name="employee_mobile"
                                        value={signupData.employee_mobile}
                                        onChange={handleChangeSignup}
                                        placeholder="Employee Mobile *"
                                        required
                                        inputProps={{
                                            inputMode: "numeric",
                                            pattern: "[6-9][0-9]{9}",
                                            maxLength: 10,
                                            minLength: 10,
                                            title: "Please enter a valid 10-digit Indian mobile number starting with 6, 7, 8, or 9",
                                        }}
                                        onKeyPress={handleKeyPress}
                                        className="custumTextField"
                                    />
                                </FormGroup>
                                <FormGroup className="customFormGroup mt-4">
                                    <TextField
                                        type={showPassword ? "text" : "password"}
                                        name="employee_password"
                                        value={signupData.employee_password}
                                        onChange={handleChangeSignup}
                                        placeholder="Password *"
                                        required
                                        className="custumTextField"
                                        InputProps={{
                                            endAdornment: (
                                                <InputAdornment position="end">
                                                    <IconButton
                                                        onClick={() =>
                                                            signupData.employee_password &&
                                                            setShowPassword(!showPassword)
                                                        }
                                                    >
                                                        {showPassword ? (
                                                            <HidePasswordIcon />
                                                        ) : (
                                                            <ShowPasswordIcon />
                                                        )}
                                                    </IconButton>
                                                </InputAdornment>
                                            ),
                                        }}
                                    />
                                </FormGroup>
                            </div>

                            <button
                                type="submit"
                                className="fillButton w-full mt-8"
                                disabled={btnLoading}
                            >
                                {btnLoading && <BtnLoader />}
                                SIGN UP
                            </button>
                            <div className={styles.forgotPassword}>
                                Already have an account? <Link to="/login">Login</Link>
                            </div>
                            <p className={styles.termsText}>
                                By signing up, you agree to our{" "}
                                <Link to="/terms">Terms & Conditions</Link>,{" "}
                                <Link to="/privacy-policy">Privacy Policy</Link>, and{" "}
                                <Link to="/pricing-policy">Pricing Policy</Link>.
                            </p>
                        </form>
                    </div>
                </section>
            </div>
        </div>
    );
};

export default Signup;
